import { render, staticRenderFns } from "./work-area-listing.vue?vue&type=template&id=791f8746&"
import script from "./work-area-listing.vue?vue&type=script&lang=js&"
export * from "./work-area-listing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports